import gql from 'graphql-tag';

export const GET_TECHNICIAN_PROMOS = gql`
	query GetTechnicianPromotions($user: String!) {
		promos(user: $user) {
			id
			name
			promoType
			discountAmount
			discountPercentage
			discountType
			uses
			maxUses
			option {
				id
				name
			}
		}
	}
`;
